import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { BlackBoxService } from '../../shared/services/pure-price/black-box.service';
import {
  Quotas,
  Supplier,
  SupplierResponseInterface,
  Survey,
} from '../../shared/interfaces/survey.interface';
import { AuthService } from '../../shared/services/auth/auth.service';
import { BuyerApiService } from '../../shared/services/buyer-api/survey.service';
import { SocketService } from '../../shared/services/socket/socket.service';
import { SupplierApiService } from '../../shared/services/supplier-api/supplier-api.service';
import { EMPTY, forkJoin, iif, of, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  DashboardQuota,
  DateRangeInterface,
  FormatQuotaInterface,
  QuotaInterface,
  QuotaResultInterface,
  TrafficChannel,
  UpdateQuotaInterface,
  ZipcodeDetailsInterface,
} from '../../shared/interfaces/manage-quotas.interface';
import { QuotaService } from '../../shared/services/quota/quota.service';
import { notifyMessage } from '../../shared/constants/notify-message';
import { NgSelectComponent } from '@ng-select/ng-select';
import { RecommendedPrice } from '../../shared/interfaces/black-box.interface';
import { Criteria } from '../../shared/interfaces/qualification.interface';
import { Constants } from '../constants/manage-quotas.constants';
import { RenameQuotaModalComponent } from './rename-quota-modal/rename-quota-modal.component';
import { QuotasInfoModalComponent } from './quotas-info-modal/quotas-info-modal.component';
import { SupplierCtUpdateWarningModalComponent } from '../../create-surveys/shared/ui/supplier-ct-update-warning-modal/supplier-ct-update-warning-modal.component';
import { PurePriceService } from '../../shared/services/pure-price/pure-price.service';
import { UserInteractionStatsQualPayload } from '../../shared/interfaces/quota.interface';
import {
  Editable,
  EditableQuota,
  EditableSupplierQuota,
} from './domain/editable';
import { UpdateQuotaEvent } from './edit-value-target/edit-current-value.component';

@Component({
  selector: 'ps-ui-manage-quotas',
  templateUrl: './manage-quotas.component.html',
  styleUrls: ['./manage-quotas.component.css'],
})
export class ManageQuotasComponent implements OnInit, OnDestroy {
  @Input() survey: Survey = {} as Survey;
  @Input() surveyId: number | undefined = 0;
  private _subscriptions: Subscription = new Subscription();

  public quotaPage: number = 1;
  public supplierPage: number = 0;
  public editCurrentTarget: {
    value: number;
    type: string;
  } = {
    value: 0,
    type: 'Percentage',
  };

  public editableCurrentTarget = new EditableQuota();
  public editableCurrentOpen = new EditableQuota();
  public editableSupplierQuotaCT = new EditableSupplierQuota();
  public editableSupplierQuotaCO = new EditableSupplierQuota();

  public editCT = false;
  public editCO = false;

  public quotas: any = {};
  public quotaLength: number = Constants.QUOTAPAGELIMIT;
  public totalQuotas!: number;
  public quotasForSupplierView: FormatQuotaInterface = {};
  public isQuotasExist: boolean = false;
  public quotaSearch: any = '';
  public checkhover: boolean = false;
  public quotaViewFlags = {
    quotaview: true,
    supplierview: false,
    priceview: false,
  };
  public zipcodeDetails!: ZipcodeDetailsInterface;

  public nickname: string = '';

  public lockQuotaImg = '../../../assets/image/lock.png';
  public unLockQuotaImg = '../../../assets/image/unlock.png';
  public isQbpChildSurvey: boolean = false;
  public toggleQuotaFilterTMStatus: boolean = false;
  public buyer: string | undefined = '';
  public operator: string | undefined = '';
  public supplier: string | undefined = '';
  public suppliers: SupplierResponseInterface[] = [];
  public filterCompanyDetail: boolean = false;
  public trCollpse: boolean = false;
  public formatQuotas: FormatQuotaInterface = {};
  public lockUnlockGroupStatus = {
    groupLockUnlockStatus: false,
    fadeoptcitylock: false,
  };
  public selectedQuotasLockUnlock: Quotas[] = [];
  public psEntryDateForDRP: string = '';
  public dateRangeOptions = {
    locale: { format: 'YYYY-MM-DD' },
    alwaysShowCalendars: false,
  };
  public dateRange = {} as DateRangeInterface;
  public psEntDtRange: string = '';
  public isActiveDate: boolean = false;
  public trafficChannel: string = '';
  public trafficChannelList: TrafficChannel[] = [];
  public channelType: boolean = false;
  public enableTrafficChannels: boolean | undefined = true;
  public selectedTrafficChannels: number[] = [];
  public readonly Constants = Constants;
  public quotaDetails!: Quotas[];
  public projectedCurrentCpi: number = 0;
  public projectedRecommendedCpi: number = 0;
  public showPriceButtonGlow: boolean = false;
  public showPriceButton: boolean = false;
  public originalOrder = () => 0;
  public hoverRow?: number;
  private _purePriceQuotas?: Quotas[];
  private _purePriceQualificationName?: string;

  constructor(
    private _buyerApiService: BuyerApiService,
    private _modal: ModalService,
    private _auth: AuthService,
    private _supplierApiService: SupplierApiService,
    private _socketService: SocketService,
    private _toastr: ToasterService,
    private _datePipe: DatePipe,
    private _quotaService: QuotaService,
    private readonly _blackBoxService: BlackBoxService,
    private readonly _purePriceService: PurePriceService
  ) {}

  ngOnInit(): void {
    this.buyer = this._auth.user?.buyerAcssLvls;
    this.operator = this._auth.user?.operatorAcssLvls;
    this.supplier = this._auth.user?.supplierAcssLvls;
    this.channelType = !this.survey.channelType;
    if (
      this.survey.is_qbp_enable &&
      this.survey.price_reco &&
      !this.survey.is_qbp_child_survey
    ) {
      this.showPriceButton = true;
    }
    this.enableTrafficChannels = this._auth.buyerConfig?.enableTrafficChannels;
    if (this.supplier === 'none') {
      this.getTrafficChannelList(this.surveyId);
    }
    this.isQbpChildSurvey = this.survey.is_qbp_child_survey;
    this._getQuotaDetails(
      this.quotaPage,
      this.quotaSearch,
      this.psEntDtRange,
      this.trafficChannel,
      true,
      false
    );

    this._socketSubscriptions();
  }

  private _socketSubscriptions() {
    this._subscriptions.add(
      this._socketService.buyerDashboardQuotaTab$.subscribe(
        (data: DashboardQuota) => {
          this._updateBuyerQuotaWithDataReceived(data);
        }
      )
    );
    this._subscriptions.add(
      this._socketService.updateQuotaSupTarget$.subscribe((data) => {
        if (!data.supplierId && data.quota) {
          // for buyer dashboard
          Object.keys(this.formatQuotas).forEach((key) => {
            this.formatQuotas[key].forEach((quota, index) => {
              const [incomingQuota] = data.quota;
              if (
                incomingQuota &&
                quota.ps_quota_id === incomingQuota.ps_quota_id
              ) {
                if (!incomingQuota.quota_title) {
                  incomingQuota.quota_title =
                    this._quotaService.breakArrayAndJoinQuotaViewItem(
                      incomingQuota.criteria
                    );
                }
                this.formatQuotas[key][index] = incomingQuota;
              }
            });
          });
        }
      })
    );
  }

  public editAllCT(selection: boolean) {
    this.editCT = selection;
    this.editCO = this.editCO && !selection;
    this.editableCurrentOpen.clear();
    this.editAll(this.editableCurrentTarget);
  }

  public editAllCO(selection: boolean) {
    this.editCO = selection;
    this.editCT = this.editCT && !selection;
    this.editableCurrentTarget.clear();
    this.editAll(this.editableCurrentOpen);
  }

  public editAll(editable: Editable) {
    const current = editable.history().length;
    if (current > 1) {
      editable.clear();
      return;
    }

    Object.keys(this.formatQuotas).forEach((key) => {
      this.formatQuotas[key].forEach((quota) => {
        editable.enable(quota.ps_quota_id);
      });
    });
  }

  public updateCurrentTarget() {
    if (this.isQbpChildSurvey) {
      return;
    }
    let supplierCurrentTargetChanged = false;
    Object.keys(this.formatQuotas).forEach((key) => {
      this.formatQuotas[key].forEach((quota) => {
        const currentTargetChangedIndex = quota.suppliers.findIndex(
          (supplier: { current_target: number; complete_needed: any }) =>
            supplier.current_target !== quota.current_target &&
            supplier.complete_needed
        );
        if (currentTargetChangedIndex > -1) {
          supplierCurrentTargetChanged = true;
        }
      });
    });
    if (supplierCurrentTargetChanged) {
      const modalRef = this._modal.open(
        SupplierCtUpdateWarningModalComponent,
        {}
      );
      modalRef.onClose$.subscribe((msg) => {
        if (msg === 'continue') {
          this._saveCurrentlyOpenData(true);
        }
        if (msg === 'continue-as-is') {
          this._saveCurrentlyOpenData(false);
        }
      });
    } else {
      this._saveCurrentlyOpenData(true);
    }
  }

  private _saveCurrentlyOpenData(updateSupplierFlag: boolean) {
    let selectedQuotaArray: QuotaInterface[] = [];
    Object.keys(this.formatQuotas).forEach((key) => {
      const matchedQuotasList = this.formatQuotas[key].filter(
        (quota) => quota.editCurrntTrgtActive === true
      );
      if (matchedQuotasList.length > 0) {
        matchedQuotasList.forEach((quota) => selectedQuotaArray.push(quota));
      }
    });
    if (!selectedQuotaArray.length) {
      Object.keys(this.formatQuotas).forEach((key) => {
        this.formatQuotas[key].forEach((quota) => {
          if (Array.isArray(quota)) {
            selectedQuotaArray = selectedQuotaArray.concat(quota);
          } else {
            selectedQuotaArray.push(quota);
          }
        });
      });
    }
    const quotaPromises: Promise<UpdateQuotaInterface>[] = [];
    selectedQuotaArray.forEach((quota) => {
      const currentTarget =
        this.editCurrentTarget.type === Constants.CURRENT_TARGET_TYPE.PERCENTAGE
          ? Math.round((this.editCurrentTarget.value * quota.maximum) / 100)
          : this.editCurrentTarget.value;
      if (quota.ps_quota_id) {
        const payload = [
          {
            op: 'replace',
            path: '/current_target',
            value: currentTarget,
            updateSupplier: updateSupplierFlag,
          },
        ];
        quotaPromises.push(
          this._buyerApiService
            .updateQuotaData(this.survey.id, quota.ps_quota_id, payload)
            .toPromise()
        );
      }
    });

    Promise.allSettled(quotaPromises)
      .then((results: PromiseSettledResult<UpdateQuotaInterface>[]) => {
        this._getQuotaDetails(
          this.quotaPage,
          this.quotaSearch,
          this.psEntDtRange,
          this.trafficChannel,
          true,
          false
        );
      })
      .catch((error) => this._toastr.error(error.msg));
  }

  private _findFormatQuota(quotaId: string) {
    return Object.values(this.formatQuotas)
      .reduce((arr, curr) => arr.concat(curr), [])
      .find((q) => q.ps_quota_id === quotaId);
  }

  public async updateEditQuotaCO({
    id: quotaId,
    value,
  }: UpdateQuotaEvent): Promise<void> {
    const quota = this._findFormatQuota(quotaId);

    const update$ = iif(
      () => !!quota && quota.currently_open !== value,
      of(quota),
      EMPTY
    ).pipe(
      map((_) => [
        {
          op: 'replace',
          path: '/current_open',
          value: value,
        },
      ]),
      switchMap((payload) =>
        this._buyerApiService.updateQuotaData(this.survey.id, quotaId, payload)
      )
    );

    const subscription = update$.subscribe(
      () => {
        quota!.currently_open = value;
      },
      (error) => {
        this.resetEditQuota(quotaId, this.editableCurrentOpen);
        return this._toastr.error(error.error.msg);
      },
      () => this.resetEditQuota(quotaId, this.editableCurrentOpen)
    );

    this._subscriptions.add(subscription);
  }

  public async updateEditQuotaCT({ id: quotaId, value }: UpdateQuotaEvent) {
    const quota = this._findFormatQuota(quotaId)!;
    if (quota) {
      let updateSupplier = true;
      const supplierCurrentTargetChanged = quota.suppliers.some(
        (supplier: { current_target: number; complete_needed: any }) =>
          supplier.current_target !== quota.current_target &&
          supplier.complete_needed
      );
      if (supplierCurrentTargetChanged) {
        const modalRef = this._modal.open(
          SupplierCtUpdateWarningModalComponent
        );
        const msg = await modalRef.onClose$.toPromise();
        if (!msg) {
          this.resetEditQuota(quotaId, this.editableCurrentTarget);
          return;
        }
        if (msg === 'continue-as-is') {
          updateSupplier = false;
        }
      }
      if (quota.current_target === value) {
        this.resetEditQuota(quotaId, this.editableCurrentTarget);
        return;
      }
      const payload = [
        {
          op: 'replace',
          path: '/current_target',
          value: value,
          updateSupplier,
        },
      ];
      try {
        await this._buyerApiService
          .updateQuotaData(this.survey.id, quotaId, payload)
          .toPromise();
        quota.current_target = value;
      } catch (error: any) {
        this._toastr.error(error.error.msg);
      }
    }
    this.resetEditQuota(quotaId, this.editableCurrentTarget);
  }

  public enableEditCT(quota: string): void {
    this.editableCurrentTarget.enable(quota);
    this.editCT = true;
  }

  public enableEditCO(quota: string): void {
    this.editableCurrentOpen.enable(quota);
    this.editCO = true;
  }

  public resetEditQuota(quotaId: string, editable: Editable) {
    this.editCT =
      this.editableCurrentTarget.history().length > 1 ? this.editCT : false;
    this.editCO =
      this.editableCurrentOpen.history().length > 1 ? this.editCO : false;

    const index = editable.disable(quotaId);
    document.getElementById(`edit_ct_${editable.history()[index]}`)?.focus();
  }

  public async updateEditSupplierCT({ id, value }: UpdateQuotaEvent) {
    const [quotaId, supplierId] = id.split(' ');
    const quota = this._findFormatQuota(quotaId)!;
    const supplier = quota.suppliers.find(
      (s: Supplier) => s.supplier_ref_id == supplierId
    );
    const payload = [
      {
        op: 'replace',
        path: '/current_target',
        value: value,
      },
    ];
    try {
      await this._buyerApiService
        .updateSupplierQuotaData(this.survey.id, quotaId, supplierId, payload)
        .toPromise();
      supplier.current_target = value;
    } catch (error: any) {
      this._toastr.error(error.error.msg);
    }
    this.resetEditSupplier(this.editableSupplierQuotaCT);
  }

  public updateEditSupplierCO({ id, value }: UpdateQuotaEvent) {
    const [quotaId, supplierId] = id.split(' ');
    const quota = this._findFormatQuota(quotaId)!;
    const supplier = quota.suppliers.find(
      (s: Supplier) => s.supplier_ref_id == supplierId
    );

    const update$ = iif(() => !!quota, of(quota!), EMPTY).pipe(
      map((_) => [
        {
          op: 'replace',
          path: '/current_open',
          value: value,
        },
      ]),
      switchMap((payload) =>
        this._buyerApiService.updateSupplierQuotaData(
          this.survey.id,
          quotaId,
          supplierId,
          payload
        )
      )
    );

    const subscription = update$.subscribe(
      () => {
        supplier.currently_open = value;
      },
      (error) => {
        this.resetEditSupplier(this.editableSupplierQuotaCO);
        return this._toastr.error(error.error.msg);
      },
      () => this.resetEditSupplier(this.editableSupplierQuotaCO)
    );

    this._subscriptions.add(subscription);
  }

  public resetEditSupplier(editable: EditableSupplierQuota) {
    editable.disable();
  }

  public quotaTrackBy(_index: number, quota: QuotaInterface): string {
    return quota.ps_quota_id;
  }

  private _getQuotaDetails(
    page: number,
    search: string,
    psEntryDateRange: string,
    trafficChannel: string,
    makeQuotaEmpty: boolean,
    isSupplierView: boolean
  ) {
    const params: any = {
      page: page ? page : 1,
      limit:
        this.quotaLength == this.totalQuotas ? '' : Constants.QUOTAPAGELIMIT,
      search: search,
    };
    if (psEntryDateRange !== '') {
      params.psEntDtRange = psEntryDateRange;
    }
    if (trafficChannel !== '') {
      params.trafficChannel = trafficChannel;
    }
    if (this._auth.userType == 'supplier') {
      const getQuotasDetail$ = this._supplierApiService
        .getQuotaDetails(this.survey.id, params)
        .subscribe((response) => {
          if (response.header) {
            this.totalQuotas = parseInt(response.header, 10);
          }
          if (response.quota) {
            this._formatQuotas(response.quota, makeQuotaEmpty);
          }
        });
      this._subscriptions.add(getQuotasDetail$);
    } else {
      const getQuotasDetail$ = this._buyerApiService
        .getQuotaDetails(this.survey.id, params)
        .subscribe((response) => {
          if (response.header) {
            this.totalQuotas = parseInt(response.header, 10);
          }
          if (response.quota) {
            this.quotaDetails = response.quota;
            if (isSupplierView) {
              this._formatQuotasForSupplierView(response.quota, makeQuotaEmpty);
              this._mapSupplierStatistics();
            } else {
              this._formatQuotas(response.quota, makeQuotaEmpty);
            }
            if (this.showPriceButton) {
              this._getUpPurePriceData();
              this._getPricingRecoQuotas();
            }
          }
        });
      this._subscriptions.add(getQuotasDetail$);
    }
  }

  public showNextQuotas(rangeQuotas: string) {
    if (rangeQuotas == Constants.SHOW_NEXT_QUOTAS_LABELS.LIMITED) {
      this.quotaPage++;
      this.quotaLength += Constants.QUOTAPAGELIMIT;
    } else if (rangeQuotas == Constants.SHOW_NEXT_QUOTAS_LABELS.ALL) {
      this.quotaLength = this.totalQuotas;
      this.quotaPage = 1;
    }
    this._getQuotaDetails(
      this.quotaPage,
      this.quotaSearch,
      '',
      '',
      false,
      false
    );
  }

  private _formatQuotas(quotas: Quotas[], makeQuotaEmpty: boolean) {
    if (makeQuotaEmpty) {
      this.formatQuotas = {};
    }
    if (quotas && quotas.length > 0) {
      quotas.forEach((quota: Quotas) => {
        if (!quota.quota_title) {
          quota.quota_title = this._quotaService.breakArrayAndJoinQuotaViewItem(
            quota.criteria
          );
        }
        if (this.formatQuotas[quota.group_key]) {
          this.formatQuotas[quota.group_key].push(quota);
        } else if (quota.quota_category !== 'default') {
          this.formatQuotas[quota.group_key] = [quota];
        }
      });
      // this function will update the position of quotas to show quotas in quota dashboard in the same order how those were entered
      this._updateQuotaPosition();
      if (Object.keys(this.formatQuotas).length > 0) {
        this.isQuotasExist = true;
      }
      if (this.quotaLength >= this.totalQuotas) {
        this._bindUnknownQuotas();
      }
    }
  }

  private _updateQuotaPosition() {
    Object.keys(this.formatQuotas).forEach((key: string) => {
      let quota = this.formatQuotas[key];
      quota.sort(function (quota1, quota2) {
        if (quota1.criteria[0].condition_codes) {
          return 1;
        } else {
          return (
            quota1.criteria[0].range_sets[0].to -
            quota2.criteria[0].range_sets[0].to
          );
        }
      });
    });
  }

  private _formatQuotasForSupplierView(
    quotas: Quotas[],
    makeQuotaEmpty: boolean
  ) {
    if (makeQuotaEmpty) {
      this.quotasForSupplierView = {};
    }
    if (quotas && quotas.length > 0) {
      quotas.forEach((quota) => {
        if (!quota.quota_title) {
          quota.quota_title = this._quotaService.breakArrayAndJoinQuotaViewItem(
            quota.criteria
          );
        }
        if (this.quotasForSupplierView[quota.group_key]) {
          this.quotasForSupplierView[quota.group_key].push(quota);
        } else if (quota.quota_category !== 'default') {
          this.quotasForSupplierView[quota.group_key] = [quota];
        }
      });
      if (Object.keys(this.quotasForSupplierView).length > 0) {
        this.isQuotasExist = true;
      }
      this._mapQuotaSuppliers();
    }
  }

  public checkQuotaFilterEnabled() {
    return (
      this.channelType &&
      (this.operator !== 'none' ||
        (this.buyer !== 'none' && this.enableTrafficChannels)) &&
      this._shouldShowTCTab(this.survey)
    );
  }
  public selectPSEntryDate(value: DateRangeInterface) {
    const startDate = this._datePipe.transform(value.start._d, 'yyyy-MM-dd');
    const endDate = this._datePipe.transform(value.end._d, 'yyyy-MM-dd');
    this.psEntryDateForDRP = `: ${startDate} - ${endDate}`;
    this.psEntDtRange = `${startDate},${endDate}`;
    this.isActiveDate = true;
    this._getQuotaDetails(
      1,
      this.quotaSearch,
      this.psEntDtRange,
      this.trafficChannel,
      true,
      false
    );
  }

  public removePSEntryDate = () => {
    this.psEntryDateForDRP = '';
    this.psEntDtRange = '';
    this.isActiveDate = false;
    this._getQuotaDetails(
      1,
      this.quotaSearch,
      this.psEntDtRange,
      this.trafficChannel,
      true,
      false
    );
  };

  public filterTrafficChannelQuotas(isApplyButtonClicked?: NgSelectComponent) {
    if (this.selectedTrafficChannels.length) {
      this.trafficChannel = this.selectedTrafficChannels.toString();
    } else {
      this.trafficChannel = '';
    }
    this._getQuotaDetails(
      1,
      this.quotaSearch,
      this.psEntDtRange,
      this.trafficChannel,
      true,
      false
    );
    if (isApplyButtonClicked) {
      isApplyButtonClicked.close();
    }
  }

  public getTrafficChannelList(surveyId: number | undefined) {
    if (surveyId) {
      this._buyerApiService
        .getTrafficChannelData(surveyId)
        .subscribe((response) => {
          this.trafficChannelList = (response || []).map((survey: any) => {
            return {
              id: survey.survey_id,
              title: survey.title,
            };
          });
        });
    } else {
      this.trafficChannelList = [];
    }
  }

  private _shouldShowTCTab(survey: Survey) {
    // Check for Include Survey
    if (survey.incl_excl == 1) {
      return false;
    }
    return true;
  }

  public openInfoModal(item: any) {
    this._modal.open(QuotasInfoModalComponent, {
      data: {
        item: item,
        survey: this.survey,
      },
      width: '770px',
    });
  }

  public lockQuota(
    surveyId: number,
    quotaName: string,
    unique_id: string,
    flag: boolean,
    index: number
  ) {
    if (this.isQbpChildSurvey) {
      return false;
    }
    if (this.supplier != 'none') {
      return false;
    }

    const payload = [
      {
        op: 'replace',
        path: '/lock',
        value: flag,
      },
    ];

    const updateQuotaData$ = this._buyerApiService
      .updateQuotaData(surveyId, unique_id, payload)
      .subscribe(
        (resp: UpdateQuotaInterface) => {
          if (this.formatQuotas[quotaName]) {
            this.formatQuotas[quotaName][index].locked = flag;
          }
          this._toastr.success(
            flag
              ? notifyMessage.successMessage.SURVEY_DETAIL_QUOTA.QUOTA_LOCKED
              : notifyMessage.successMessage.SURVEY_DETAIL_QUOTA.QUOTA_UNLOCKED
          );
        },
        (error) => {
          this._toastr.error(error.error.msg);
        }
      );
    this._subscriptions.add(updateQuotaData$);
    return true;
  }

  public searchQuotas(searchKeyword: string) {
    const quotaPage = 1;
    this.quotaSearch = searchKeyword;
    this.formatQuotas = {};
    this._getQuotaDetails(
      quotaPage,
      searchKeyword,
      this.psEntDtRange,
      this.trafficChannel,
      true,
      false
    );
  }

  //Avoid to select row on click lock/unlock
  public avoidClick = (e: Event) => {
    e.stopPropagation();
  };

  public manageCap(input: any) {
    if (!input) {
      return input;
    }
    let modifiedInput = input.toString().replace(new RegExp(',', 'g'), '');
    modifiedInput = parseInt(modifiedInput);
    if (modifiedInput < 0) {
      return 0;
    } else if (modifiedInput > 9999) {
      return '-';
    } else {
      return input;
    }
  }

  public progress(survey: Survey, item: QuotaInterface) {
    const progress =
      (survey.click_balancing === 1
        ? this.manageCap(item.buyer_valid_clks) / item.required_count
        : item.achieved / item.required_count) * 100;

    return Math.min(progress, 100);
  }

  public toggleQuotaFilterTM() {
    this.toggleQuotaFilterTMStatus = !this.toggleQuotaFilterTMStatus;
  }

  public setHeaderQuotaView() {
    this.quotaViewFlags.quotaview = true;
    this.quotaViewFlags.supplierview = false;
    this.quotaViewFlags.priceview = false;
  }

  public getSuppliers(surveyId: number) {
    this.quotaViewFlags.supplierview = true;
    this.quotaViewFlags.quotaview = false;
    this.quotaViewFlags.priceview = false;
    const getSuppliers$ = this._buyerApiService
      .getSuppliers(surveyId, 'view')
      .subscribe((response: SupplierResponseInterface[]) => {
        this.suppliers = response;
        this.suppliers = this.suppliers.filter((supplier) => {
          return supplier.completes_goal || supplier.srv_start_count;
        });
        this._paginatedQuotaListForSupTab();
        this._mapSuppliersGroupRef(this.suppliers);
      });
    this._subscriptions.add(getSuppliers$);
  }

  public openPriceQuotaView() {
    this.quotaViewFlags.quotaview = false;
    this.quotaViewFlags.supplierview = false;
    this.quotaViewFlags.priceview = true;
  }
  public isObjKeysEmpty(object: any) {
    let empty = false;
    if (object != {}) {
      Object.keys(object).forEach((key) => {
        if (object[key].length > 0) {
          empty = true;
        }
      });
      if (empty) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  public _mapSuppliersGroupRef(suppliers: SupplierResponseInterface[]) {
    suppliers.forEach((sup) => {
      if (!sup.group_ref) {
        sup.group_ref = sup.suppliers[0].id;
        sup.isGrouped = false;
        sup.group_name = sup.suppliers[0].name;
      } else {
        sup.isGrouped = true;
      }
    });
  }

  private _bindUnknownQuotas() {
    Object.keys(this.formatQuotas).forEach((key: string) => {
      const quota = this.formatQuotas[key];
      let quotaAchived = 0;
      quota.forEach((quotaItem: Quotas) => {
        quotaAchived += quotaItem.achieved;
      });
      let unknownFielded = quota[0].in_field
        ? this.survey.fielded - quotaAchived
        : 0;
      if (unknownFielded && unknownFielded > 0) {
        quota.push({
          buyer_quota_id: '',
          ps_quota_id: '',
          required_count: quota[0].required_count,
          criteria: [],
          locked: false,
          last_complete_date: '',
          bip: 0,
          buyer_valid_clks: 0,
          current_target: 0,
          currently_open: 0,
          sup_currently_open: 0,
          maximum: 0,
          minimum: 0,
          percentage: 0,
          quota_category: '',
          group_key: '',
          suppliers: [],
          in_field: {
            total_complete: 0,
            crtd_on: 0,
          },
          quantities: {
            remaining: 0,
            currently_open: 0,
            achieved: 0,
          },
          flexible: {
            enable: false,
            value: 0,
          },
          achieved: unknownFielded,
          quota_title: 'Unknown',
          name: [{ name: 'Unknown' }],
          isUnknown: true,
          diffCpi: 0,
          priceRecommendCpi: 0,
          qbp: {
            cpi: 0,
            enabled: false,
            surveyId: this.survey.id,
            quota_ids: [],
            selectedQuotaIds: [],
            category: '',
          },
        });
      }
    });
  }

  private _mapQuotaSuppliers() {
    for (let key in this.quotasForSupplierView) {
      this.quotasForSupplierView[key].forEach((quota: QuotaInterface) => {
        if (quota.suppliers && quota.suppliers.length) {
          const tempSupObj: any = {};
          quota.suppliers.forEach((sup: any) => {
            tempSupObj[sup.supplier_ref_id] = sup;
          });
          quota.suppliers = tempSupObj;
        }
      });
    }
  }

  public openZipcodesGroupModalForQuotaTab(criteria: any) {
    if (criteria) {
      this.zipcodeDetails = {
        zipcode: criteria.condition_codes,
        groupNo: criteria.condition_names[0],
      };
    } else {
      this.zipcodeDetails = { zipcode: '', groupNo: '' };
      this._toastr.error(notifyMessage.errorMessage.NO_ZIP_CODE_FOUND);
    }
  }

  public openInfoSupplierModal(item: Quotas) {
    this._modal.open(QuotasInfoModalComponent, {
      data: {
        item: item,
        survey: this.survey,
      },
    });
  }

  /* Function to maintain Selected Quota Array for Group Lock/Unlock
   *{@Parms} surveyID , quotaName(age, gender....etc.), unique_id(ps quota id)
   */
  public checkGroupLockUnlockQuotaStatus(
    surveyId: number,
    quotaName: string,
    unique_id: string,
    index: number
  ) {
    this.formatQuotas[quotaName][index].editCurrntTrgtActive =
      !this.formatQuotas[quotaName][index].editCurrntTrgtActive;
    let selectedQuotaArray: Quotas[] = [];
    Object.keys(this.formatQuotas).forEach((key: string) => {
      const qutasArray = this.formatQuotas[key];
      const matchedQuotaList = qutasArray.filter((filterQuota) => {
        if (
          filterQuota.editCurrntTrgtActive === true &&
          unique_id == filterQuota.ps_quota_id
        ) {
          filterQuota.quota_category = quotaName;
        }
        return filterQuota.editCurrntTrgtActive === true;
      });
      selectedQuotaArray = [...selectedQuotaArray, ...matchedQuotaList];
    });
    this.selectedQuotasLockUnlock = selectedQuotaArray;
    const unlockQuotas = [];
    const lockQuotas = [];
    selectedQuotaArray.forEach((selectQuota) => {
      if (selectQuota.locked === false) {
        unlockQuotas.push(selectQuota);
      }
      if (selectQuota.locked === true) {
        lockQuotas.push(selectQuota);
      }
    });
    // manage lock button status
    this._setGroupStatus(
      unlockQuotas.length,
      lockQuotas.length,
      selectedQuotaArray.length
    );
  }

  private _setGroupStatus(
    unLockedQuotasLength: number,
    lockedQuotasLength: number,
    selectedQuotasLength: number
  ) {
    this.lockUnlockGroupStatus.groupLockUnlockStatus = true;
    if (
      (!unLockedQuotasLength && !selectedQuotasLength) ||
      this.isQbpChildSurvey
    ) {
      this.lockUnlockGroupStatus.fadeoptcitylock = false;
    }
    if (
      unLockedQuotasLength === selectedQuotasLength ||
      (unLockedQuotasLength && lockedQuotasLength)
    ) {
      this.lockUnlockGroupStatus.groupLockUnlockStatus = false;
      this.lockUnlockGroupStatus.fadeoptcitylock = true;
    }
  }

  public updateLockUnlockQuotaGroup(surveyId: number) {
    if (this.selectedQuotasLockUnlock.length > 0) {
      const surveysPromise: any = [];
      const rejectedList: Quotas[] = [];
      this.selectedQuotasLockUnlock.forEach((element, id) => {
        if (
          element.locked === this.lockUnlockGroupStatus.groupLockUnlockStatus
        ) {
          const payload = [
            {
              op: 'replace',
              path: '/lock',
              value: !element.locked,
            },
          ];
          surveysPromise.push(
            this._buyerApiService
              .updateQuotaData(surveyId, element.ps_quota_id, payload)
              .toPromise()
              .then((result) => {
                const quotaName = element.group_key;
                this.formatQuotas[quotaName].forEach((quota, index) => {
                  if (
                    this.formatQuotas[quotaName][index].ps_quota_id ===
                    element.ps_quota_id
                  ) {
                    this.formatQuotas[quotaName][index].locked =
                      !this.lockUnlockGroupStatus.groupLockUnlockStatus;
                  }
                });
              })
          );
        }
      });
      Promise.allSettled(surveysPromise).then((results: any) => {
        results.forEach((result: QuotaResultInterface) => {
          if (result.status == 'rejected') {
            rejectedList.push(result.value);
          }
        });
        const msg = this.lockUnlockGroupStatus.groupLockUnlockStatus
          ? notifyMessage.successMessage.SURVEY_DETAIL_QUOTA.QUOTA_UNLOCKED
          : notifyMessage.successMessage.SURVEY_DETAIL_QUOTA.QUOTA_LOCKED;

        if (rejectedList.length) {
          this._toastr.error(
            `Error:  ${msg} ${notifyMessage.errorMessage.Quota.STATUS_CHANGED_ERROR_MESSAGE}`
          );
        } else {
          this._toastr.success(`Success: ${msg}`);
        }
        this.selectedQuotasLockUnlock = [];
        this.lockUnlockGroupStatus = {
          groupLockUnlockStatus: false,
          fadeoptcitylock: false,
        };
      });
    } else {
      this._toastr.error(
        notifyMessage.warningMessage.QUOTA.SELECT_QUOTA_LOCK_UNLOCK
      );
    }
  }

  private _updateBuyerQuotaWithDataReceived(data: DashboardQuota) {
    const isTheCurrentSurvey = this.surveyId === data.surveyId;
    const hasQuota = !!(
      this.formatQuotas !== {} &&
      data.quota &&
      data.quota.length
    );

    if (
      !data.surveyId ||
      !hasQuota ||
      !isTheCurrentSurvey ||
      this.toggleQuotaFilterTMStatus
    ) {
      return false;
    }

    data.quota.forEach((updatedQuota) => {
      if (this.formatQuotas[updatedQuota.group_key]) {
        this.formatQuotas[updatedQuota.group_key] = this.formatQuotas[
          updatedQuota.group_key
        ].map((quota) =>
          quota.ps_quota_id === updatedQuota.ps_quota_id ? updatedQuota : quota
        );
      }
    });
    return true;
  }

  private _mapSupplierStatistics() {
    if (
      this.suppliers.length &&
      Object.keys(this.quotasForSupplierView).length
    ) {
      this.suppliers.forEach((supplier: any) => {
        supplier.current_target_stats = 0;
        supplier.currently_open_stats = 0;
        supplier.valid_click_sum = 0;
        Object.keys(this.quotasForSupplierView).forEach(
          (key: string, index) => {
            const supplierQuota = this._manageSupplierQuota(
              this.quotasForSupplierView[key],
              supplier
            );
            let quota_current_target_sum =
              supplierQuota.quota_current_target_sum;
            let quota_currently_open_sum =
              supplierQuota.quota_currently_open_sum;
            supplier = supplierQuota.supplier;
            if (index) {
              supplier.current_target_stats = Math.min(
                supplier.current_target_stats,
                quota_current_target_sum
              );
              supplier.currently_open_stats = Math.min(
                supplier.currently_open_stats,
                quota_currently_open_sum
              );
            } else {
              supplier.current_target_stats = quota_current_target_sum;
              supplier.currently_open_stats = quota_currently_open_sum;
            }
          }
        );
      });
    }
  }

  private _manageSupplierQuota(
    formatQuotas: QuotaInterface[],
    supplier: SupplierResponseInterface
  ) {
    let quota_current_target_sum = 0;
    let quota_currently_open_sum = 0;
    formatQuotas.forEach((quota: QuotaInterface) => {
      if (supplier.group_ref) {
        quota_current_target_sum =
          quota_current_target_sum +
          quota.suppliers[supplier.group_ref].current_target;
        quota_currently_open_sum =
          quota_currently_open_sum +
          (quota.locked
            ? 0
            : quota.suppliers[supplier.group_ref].sup_currently_open);
        supplier.valid_click_sum =
          supplier.valid_click_sum +
          quota.suppliers[supplier.group_ref].buyer_valid_clks;
      }
    });
    return { quota_current_target_sum, quota_currently_open_sum, supplier };
  }

  private _paginatedQuotaListForSupTab() {
    this._getQuotaDetails(
      1,
      this.quotaSearch,
      this.psEntDtRange,
      this.trafficChannel,
      true,
      true
    );
  }

  public suppConversion(
    suppliers: { [key: string]: Supplier },
    groupRref?: string | number
  ) {
    if (
      groupRref &&
      suppliers[groupRref] &&
      suppliers[groupRref]['complete_fielded'] != 0 &&
      suppliers[groupRref]['buyer_valid_clks'] - suppliers[groupRref]['bip'] !=
        0
    ) {
      return (
        (suppliers[groupRref]['complete_fielded'] * 100) /
        (suppliers[groupRref]['buyer_valid_clks'] - suppliers[groupRref]['bip'])
      );
    } else {
      return '-';
    }
  }

  public suppConversionQuota(supplier: Supplier) {
    if (
      supplier['complete_fielded'] != 0 &&
      supplier['buyer_valid_clks'] - supplier['bip'] != 0
    ) {
      return (
        (supplier['complete_fielded'] * 100) /
        (supplier['buyer_valid_clks'] - supplier['bip'])
      );
    }
    return '-';
  }

  public updateQuotaTitle(
    quotaId: string,
    quotaName: string,
    quotaCriteria: Criteria[],
    quotaKey: string,
    quotaIndex: number
  ) {
    const modalRef = this._modal.open(RenameQuotaModalComponent, {
      data: {
        ps_quota_id: quotaId,
        survey_id: this.surveyId,
        quota_name: quotaName,
        quota_key: quotaKey,
        quota_index: quotaIndex,
        quota_criteria: quotaCriteria,
      },
    });

    modalRef.onClose$.subscribe((response) => {
      response = JSON.parse(response);
      if (response.msg == 'success') {
        this.formatQuotas[quotaKey][quotaIndex].quota_title =
          response.newQuotaName;
      }
    });
  }

  private _getPricingRecoQuotas() {
    const quotaPromises = this._purePriceQuotas!.map((quota) => {
      const mappedSurveyData = this._blackBoxService.mapIntoBlackboxSurveyData(
        this.survey
      );
      const quotaPayload = this._blackBoxService.generateBlackBoxPayload(
        quota,
        mappedSurveyData
      );
      return this._blackBoxService.getRecommendedCpi(quotaPayload);
    });

    forkJoin(quotaPromises).subscribe((results: RecommendedPrice[]) => {
      if (!results) {
        return;
      }
      this._purePriceQuotas!.forEach((singleQuota: Quotas, index: number) => {
        singleQuota.priceRecommendCpi = results[index].price_recommendation;
        singleQuota.EPC = results[index].EPC;
        singleQuota.loss_ratio = results[index].loss_ratio;
        singleQuota.diffCpi = this._getDifferenceOfCpis(
          singleQuota,
          results[index].price_recommendation
        );
      });
      this._getProjectedCpiObject();
    });
  }

  public updateQuotaPriceStats() {
    const purePriceQuotasToUpdateStatus: Array<UserInteractionStatsQualPayload> =
      this._purePriceService.mapQuotaToUserInteractionStatsQualPayload(
        this._purePriceQuotas!
      );
    this._purePriceService.setUserInteraction(
      this.survey.id,
      Number(this.survey.loi.overall),
      Number(this.survey.incidence.overall),
      this._purePriceQualificationName!,
      purePriceQuotasToUpdateStatus
    );
  }

  private _getUpPurePriceData() {
    this._purePriceQuotas = this.quotaDetails.filter((quota) => quota.qbp);
    this._purePriceQualificationName = this._purePriceQuotas[0].group_key;
  }

  private _getDifferenceOfCpis(
    qbpQuota: Quotas,
    recommendedBlackBoxCpi: number
  ) {
    if (qbpQuota && qbpQuota.qbp) {
      return Number((recommendedBlackBoxCpi - qbpQuota.qbp.cpi).toFixed(2));
    }
    return 0;
  }

  private _getProjectedCpiObject = () => {
    const qbpQuotas = this._getQbpOnlyQuotas();
    this.projectedCurrentCpi = this._calculateTotalProjectCostOfQbpParent(
      qbpQuotas,
      true
    );
    this.projectedRecommendedCpi = this._calculateTotalProjectCostOfQbpParent(
      qbpQuotas,
      false
    );
    this._highlightPriceButton();
  };

  private _highlightPriceButton(): void {
    this.showPriceButtonGlow =
      this.projectedCurrentCpi !== this.projectedRecommendedCpi;
  }

  private _getQbpOnlyQuotas = () => {
    return this.quotaDetails.filter((quota: Quotas) => quota.qbp?.enabled);
  };

  private _calculateTotalProjectCostOfQbpParent(
    qbpQuotas: Quotas[],
    isDefaultCalc: boolean
  ) {
    return qbpQuotas.reduce((projectedCpi, qbpQuota) => {
      const cpi = isDefaultCalc
        ? qbpQuota.qbp!.cpi
        : qbpQuota.priceRecommendCpi;
      return (
        projectedCpi +
        (this.survey.totalCost.current +
          (qbpQuota.required_count - qbpQuota.achieved) * cpi)
      );
    }, 0);
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
